import { type TypedDocumentNode, gql } from '@apollo/client';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { HeadlineS } from '@sorare/core/src/atoms/typography';
import { CollectionGameHelper } from '@sorare/core/src/components/collections/CollectionGameHelper';

import type { CollectionUpsellTitle_cardCollection } from './__generated__/index.graphql';

const Title = styled(Horizontal)`
  padding: 0 var(--double-unit);
`;

const Wrapper = styled(Vertical).attrs({ gap: 2 })`
  padding: var(--unit);
  max-width: 300px;
`;

type Props = {
  cardCollection: CollectionUpsellTitle_cardCollection;
};

export const CollectionUpsellTitle = ({ cardCollection }: Props) => {
  return (
    <Title>
      <HeadlineS>
        <FormattedMessage
          id="cart.collectionUpsell.title"
          defaultMessage="Boost your collections"
        />
      </HeadlineS>
      <Tooltip
        title={
          <Wrapper>
            <CollectionGameHelper cardCollection={cardCollection} />
          </Wrapper>
        }
      >
        <FontAwesomeIcon icon={faInfoCircle} color="var(--c-nd-600)" />
      </Tooltip>
    </Title>
  );
};

CollectionUpsellTitle.fragments = {
  cardCollection: gql`
    fragment CollectionUpsellTitle_cardCollection on CardCollection {
      slug
      ...CollectionGameHelper_cardCollection
    }
    ${CollectionGameHelper.fragments.cardCollection}
  ` as TypedDocumentNode<CollectionUpsellTitle_cardCollection>,
};
